import { Slide } from "@jelly/lesson";
import theory from "../../theory";
import config from "appConfig";

const principle: Slide = {
  theory: theory,
  descriptionHtml:
    "Due to limited capabilities of traditional methods to reflect the depth of experiential qualities associated with spatial hearing, a more advanced, custom methodologies have been proposed. One example is ADA method (developed by Dolby [No]) that allows high dimensional capture of subjective experiences of sound localization and quality. In this section one of a basic application of ADA method is presented - evaluation of binaural audio systems performance in the context of spatial localization.<br><br>Now perform a test similar to the one described on the previous page. However, please note that unlike the true ADA test, which is conducted in a dedicated test room, the available locations are limited to 72 discrete points evenly spaced at a fixed distance. In addition, this example does not allow you to specify the height (angle of elevation) and dispersion of the sound source. Use headphones to listen to the provided audio samples and pinpoint the perceived location of the stimuli on three different binaural virtualizers (systems B and C are shown on the following pages). On the last page, the actual location of the stimuli is revealed.",
  layout: {
    type: "table",

    options: {
      rows: 1,
      cols: 2,
      colsSize: [1, 2],
      components: [
        [
          [
            {
              variant: "blockContainer",
              data: {
                block: {
                  type: "audioButton",
                  options: {
                    theme: "default",
                    text: "System A",
                    icon: "cis-volume-high",
                    shape: "round",
                    size: "standard",
                    loop: true,
                    url: `${config.ASSETS_URL}/02/26/principle/system_a.mp3`,
                  },
                },
                styles: {
                  alignItems: "center",
                },
              },
            },
          ],
          [
            {
              variant: "blockContainer",
              data: {
                block: {
                  type: "panner",
                  options: {
                    audio: [],
                    hideIcon: true,
                  },
                },
              },
            },
          ],
        ],
      ],
    },
  },
};

export default principle;
